export default {
  redirectUrl: (state) => state.redirectUrl,
  sidebar: (state) => state.sidebar,
  numberOfElements: (state) => state.numberOfElements,
};
